import { LoadingSpinner } from "./loading-spinner";

interface TableLoadingSpinnerProps {
  colSpan?: number;
}

export function TableLoadingSpinner({ colSpan: _colSpan = 6 }: TableLoadingSpinnerProps) {
  return (
    <div className="flex items-center justify-center h-[400px]">
      <LoadingSpinner size="md" />
    </div>
  );
}
